/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ActionsAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Content from './Content/index'
import Delete from './Delete/index'
import Edit from './Edit/index'
import Popover from 'DesignSystem/Popover/index'
import PopoverContentLeftClick from 'DesignSystem/Popover/PopoverContentLeftClick/index'
import PopoverTrigger from 'DesignSystem/Popover/PopoverTrigger/index'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import TysiaIconArrowDown from 'DesignSystem/Svgs/TysiaIconArrowDown/index'



/** @type {import('Simple/types.js').View} */
export default function ActionsAction({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Procedures/Content/Content/Procedure/ActionsAction",
  ignoreClickOutsideIf,
  isSubmitting,
  data
  
}) {
let selectedIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'selected',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<Popover
  viewPath={`${viewPath}/Popover`}
 ignoreClickOutsideIf={ignoreClickOutsideIf}
 placement="bottom-end"
 offsetCrossAxis={4}
 offsetMainAxis={4}
 width={240}
>
{childProps => (
<React.Fragment>
<PopoverTrigger
{...childProps}
  viewPath={`${viewPath}/PopoverTrigger`}
>
{childProps => (
<TysiaButton
{...childProps}
  viewPath={`${viewPath}/TysiaButton`}
 marginLeft={dtSpaceXxs}
 alignSelf="flex-end"
 type="secondary"
 size="small"
 data="selected"
 disabled={selectedIsSubmittingData}
>
{childProps => (
<React.Fragment>
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Actions"
/>
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
 marginLeft={dtSpaceXxs}
>
{childProps => (
<TysiaIconArrowDown
{...childProps}
  viewPath={`${viewPath}/TysiaIconArrowDown`}
 width={9}
 height={9}
/>
)}
</TysiaButtonIcon>
</React.Fragment>
)}
</TysiaButton>
)}
</PopoverTrigger>
<PopoverContentLeftClick
{...childProps}
  viewPath={`${viewPath}/PopoverContentLeftClick`}
>
{childProps => (
<Content
{...childProps}
  viewPath={`${viewPath}/Content`}
 data={data}
/>
)}
</PopoverContentLeftClick>
</React.Fragment>
)}
</Popover>
<Edit
  viewPath={`${viewPath}/Edit`}
/>
<Delete
  viewPath={`${viewPath}/Delete`}
/>
{children}
</React.Fragment>)
}